/**
 * @generated SignedSource<<a54422ffbae7fdbf9db8ab2862c0c63d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ImportExistingTicketPaneTrelloQuery$variables = {
  search: string;
};
export type ImportExistingTicketPaneTrelloQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly trello: {
        readonly searchCards: ReadonlyArray<{
          readonly board: {
            readonly externalId: string;
            readonly id: string;
            readonly name: string;
          };
          readonly due: string | null;
          readonly externalId: string | null;
          readonly id: string;
          readonly list: {
            readonly externalId: string;
            readonly id: string;
            readonly name: string;
          };
          readonly member: {
            readonly fullName: string;
            readonly id: string;
            readonly image: string;
          } | null;
          readonly name: string;
        }> | null;
      } | null;
    };
  };
};
export type ImportExistingTicketPaneTrelloQuery = {
  response: ImportExistingTicketPaneTrelloQuery$data;
  variables: ImportExistingTicketPaneTrelloQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "query",
      "variableName": "search"
    }
  ],
  "concreteType": "TrelloCardSearchNode",
  "kind": "LinkedField",
  "name": "searchCards",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "member",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "image",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "due",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TrelloBoardNode",
      "kind": "LinkedField",
      "name": "board",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TrelloListNode",
      "kind": "LinkedField",
      "name": "list",
      "plural": false,
      "selections": (v4/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImportExistingTicketPaneTrelloQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TrelloUserNode",
                "kind": "LinkedField",
                "name": "trello",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImportExistingTicketPaneTrelloQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TrelloUserNode",
                "kind": "LinkedField",
                "name": "trello",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2d85cd691d48c612f4930f552b9a050d",
    "id": null,
    "metadata": {},
    "name": "ImportExistingTicketPaneTrelloQuery",
    "operationKind": "query",
    "text": "query ImportExistingTicketPaneTrelloQuery(\n  $search: String!\n) {\n  viewer {\n    integrations {\n      trello {\n        searchCards(query: $search) {\n          id\n          externalId\n          member {\n            id\n            fullName\n            image\n          }\n          name\n          due\n          board {\n            id\n            externalId\n            name\n          }\n          list {\n            id\n            externalId\n            name\n          }\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c9010ae4ce237583e1f8ee06c047924a";

export default node;
